import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import translationEN from './translations/en/en.json'
import translationHE from './translations/he/he.json'

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: translationEN,
    },
    he: {
      translation: translationHE,
    },
  },
  fallbackLng: 'he',
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
})

export default i18n
